<template>
    <FormModel
        :action="submit" :label-col="{span: 5}"
        :model="logo" :rules="ConstValue.logoRules"
        :wrapper-col="{span: 19}" ref="logoForm" style="width: 480px;">
        <a-form-model-item label="个人头像" prop="avatar" required style="margin-bottom: 13px;">
            <div style="width:120px; float:left;">
                <ImageUpload :height="100" :width="100" title="上传头像" v-model="logo.avatar"/>
            </div>
            <div style="line-height:22px; padding-top:30px; float:left;">
                <div>1. 仅支持 JPG 或 PNG 格式</div>
                <div>2. 建议上传尺寸 300px * 300px</div>
            </div>
        </a-form-model-item>
        <a-form-model-item label="站内昵称" prop="nick">
            <a-input placeholder="请输入您的昵称" v-model="logo.nick"/>
        </a-form-model-item>
        <a-form-model-item label="自我简介">
            <a-input placeholder="不超过250个字符" rows="5" type="textarea" v-model="logo.motto"/>
        </a-form-model-item>
    </FormModel>
</template>

<script>
    import api from "../../../utils/api";
    import func from "../../../utils/func";
    import ConstValue from "./ConstValue";
    import ImageUpload from "../../../comps/ImageUpload";
    import FormModel from "../../../comps/FormModel";

    export default {
        name: "Logo",
        components: {FormModel, ImageUpload},
        props: {user: Object},
        data() {
            return {
                logo: {nick: "", motto: "", avatar: ""},
                ConstValue: ConstValue
            }
        },
        mounted() {
            this.logo = func.copyObject(this.user.logo);
        },
        methods: {
            submit() {
                return api.v1.user.setLogo(this.logo)
                    .then(() => this.user.logo = this.logo);
            }
        }
    }
</script>
